import React, { useState, useMemo, useEffect, useContext } from 'react';
// import Swal from 'sweetalert2';
import moment from 'moment';
// MUI
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import useStore from '../../states/store';
import { DashboardProvider } from '../Dashboard/useDashboard';
import TabPanel from '../../components/TabPanel';
// Components
import Filter from './components/Filter';
import ClientCallOutTab from './components/ClientCallOutTab';
// API
import { getCncDashboard, getCncDashboardDetails, getCncDashboardMoe } from '../../api/ccoApi';
// Context
import useClientCallOutDashboard from './context/useClientCallOutDashboard';
import AppConst from '../../components/AppLayout/const';

export default function ClientCallOutDashboard() {
  const auth = useStore((state) => state.auth);

  const defaultFilter = {
    month_year: moment().format('YYYY-MM'),
  };
  const { onSetTitle } = useContext(AppConst.AppContext);
  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [clearFilter, setClearFilter] = useState(0);
  const [cncDashboard, setCncDashboard] = useState({ loading: true, table: [] });
  const [cncDashboardDtl, setCncDashboardDtl] = useState({ loading: true, table: [] });
  const [cncDashboardMoe, setCncDashboardMoe] = useState({ loading: true, table: [] });

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  onSetTitle('Client Call Out Dashboard');

  const handleCncReport = async () => {
    try {
      setCncDashboard({ ...cncDashboard, loading: true });
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: Number(moment(filterForm?.month_year).format('M')),
        year: Number(moment(filterForm?.month_year).format('YYYY')),
      };
      const response = await getCncDashboard(request);
      const { code, data } = response.data;

      if (code === '200') {
        setCncDashboard({ ...cncDashboard, loading: false, table: data });
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCncDtlReport = async () => {
    try {
      setCncDashboardDtl({ ...cncDashboardDtl, loading: true });
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: Number(moment(filterForm?.month_year).format('M')),
        year: Number(moment(filterForm?.month_year).format('YYYY')),
      };
      const response = await getCncDashboardDetails(request);
      const { code, data } = response.data;

      if (code === '200') {
        setCncDashboardDtl({ ...cncDashboardDtl, loading: false, table: data });
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleCncMoeReport = async () => {
    try {
      setCncDashboardMoe({ ...cncDashboardMoe, loading: true });
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: Number(moment(filterForm?.month_year).format('M')),
        year: Number(moment(filterForm?.month_year).format('YYYY')),
      };
      const response = await getCncDashboardMoe(request);
      const { code, data } = response.data;

      if (code === '200') {
        setCncDashboardMoe({ ...cncDashboardMoe, loading: false, table: data });
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleGenerateFilter = () => {
    handleCncReport();
    handleCncDtlReport();
    handleCncMoeReport();
  };

  const handleClearFilter = () => {
    setFilterForm(defaultFilter);
    const rand = moment().format('msS');
    setClearFilter(rand);
  };

  useEffect(() => {
    handleGenerateFilter();
  }, [clearFilter]);
  return (
    <DashboardProvider>
      <useClientCallOutDashboard.Provider
        value={useMemo(
          () => ({
            // GET
            activeTab,
            auth,
            filterForm,
            clearFilter,
            cncDashboard,
            cncDashboardDtl,
            cncDashboardMoe,
            // SET
            setFilterForm,
            setClearFilter,

            // METHOD
            handleGenerateFilter,
            handleClearFilter,
            handleChangeActiveTab,
          }),
          [filterForm, cncDashboard, cncDashboardDtl, cncDashboardMoe],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={12}>
              <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChangeActiveTab}
                    aria-label='basic tabs example'
                  >
                    <Tab
                      label='Client Call Out'
                      id='client-call-out-tab'
                      aria-controls='client-call-out-tab'
                      name='client-call-out-tab'
                    />
                  </Tabs>
                </Box>
                <TabPanel value={activeTab} index={0}>
                  <ClientCallOutTab />
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </useClientCallOutDashboard.Provider>
    </DashboardProvider>
  );
}
